module.exports = __webpack_public_path__ + "images/avatars/female/6.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/6.png
// module id = JiAo
// module chunks = 151